export default __webpack_public_path__ + "static/media/13.4982170b.jpg";